import { SituacaoEnum } from '@/utils/enumerados';
import elementoVisivel from '../dom';

const SELECTOR_SITUACAO = '[data-tour="situacao"]';
const SELECTOR_OBTER_ATA = '[data-tour="encerrada-recurso-obter-ata"]';
const SELECTOR_EXPORTAR = '[data-tour="encerrada-recurso-exportar"]';
const SELECTOR_ABA_ATA = '[data-tour="encerrada-recurso-ata"]';
const SELECTOR_ABA_TERMOS = '[data-tour="encerrada-recurso-termos"]';
const SELECTOR_ABA_RECURSOS = '[data-tour="prazos-recursais-aba-recursos"]';
const SELECTOR_ABA_ATOS = '[data-tour="encerrada-recurso-atos"]';

export default {
  id: 'encerrada-com-recurso',
  kind: 'tour',
  version: 1,
  label: 'Encerrada com recurso',
  contexts: ['auction.situation'],
  situation: SituacaoEnum.ENCERRADA_COM_RECURSO,
  priority: 10,
  help: true,
  canStart(ctx = {}) {
    if (!ctx.logged) return false;
    if (Number(ctx.situation) !== SituacaoEnum.ENCERRADA_COM_RECURSO) return false;
    return elementoVisivel(SELECTOR_SITUACAO);
  },
  steps() {
    const steps = [
      {
        element: SELECTOR_SITUACAO,
        popover: {
          title: 'Encerrada com Recurso',
          description:
            'A sessão foi encerrada após a fase recursal. Aqui você consulta o resultado final, documentos oficiais e o histórico dos recursos.',
          side: 'bottom',
          align: 'center',
        },
      },
    ];

    if (elementoVisivel(SELECTOR_OBTER_ATA)) {
      steps.push({
        element: SELECTOR_OBTER_ATA,
        popover: {
          title: 'Obter Ata',
          description:
            'Gere a ata da sessão pública. Depois de emitida, ela fica disponível na aba Ata para consulta e download.',
          side: 'bottom',
          align: 'center',
        },
      });
    }

    if (elementoVisivel(SELECTOR_EXPORTAR)) {
      steps.push({
        element: SELECTOR_EXPORTAR,
        popover: {
          title: 'Exportar Integração',
          description:
            'Exporte os dados do processo para integração com outros sistemas, quando necessário.',
          side: 'bottom',
          align: 'center',
        },
      });
    }

    if (elementoVisivel(SELECTOR_ABA_ATA)) {
      steps.push({
        element: SELECTOR_ABA_ATA,
        popover: {
          title: 'Aba Ata',
          description:
            'Consulte e baixe a ata oficial da sessão pública gerada para este processo.',
          side: 'bottom',
          align: 'start',
        },
      });
    }

    if (elementoVisivel(SELECTOR_ABA_TERMOS)) {
      steps.push({
        element: SELECTOR_ABA_TERMOS,
        popover: {
          title: 'Aba Termos',
          description:
            'Acesse os termos de adjudicação e homologação quando já tiverem sido emitidos.',
          side: 'bottom',
          align: 'start',
        },
      });
    }

    if (elementoVisivel(SELECTOR_ABA_RECURSOS)) {
      steps.push({
        element: SELECTOR_ABA_RECURSOS,
        popover: {
          title: 'Aba Recursos',
          description:
            'Revise os recursos, contrarrazões e o julgamento que acompanharam o encerramento do processo.',
          side: 'bottom',
          align: 'start',
        },
      });
    }

    if (elementoVisivel(SELECTOR_ABA_ATOS)) {
      steps.push({
        element: SELECTOR_ABA_ATOS,
        popover: {
          title: 'Atos Decisórios',
          description:
            'Consulte os atos decisórios do processo (adjudicação, homologação e demais decisões registradas).',
          side: 'bottom',
          align: 'start',
        },
      });
    }

    return steps;
  },
};
